// FUNCTIONS
//:include('./_functions/_jq/supportWebp.js')
//:include('./_functions/_jq/setAppHeight.js')
//:include('./_functions/_jq/setScrollWidth.js')
//:include('./_functions/info.js')
// MAIN
$(document).ready(function() {
    supportWebp();
    setAppHeight();
    setScrollWidth();

    // smooth scroll
    /*
    const lenis = new Lenis({
        anchors: {
            offset: -65,
        },
        duration: 1.8,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        orientation: 'vertical',
        gestureOrientation: 'vertical',
        smooth: true,
        smoothTouch: false,
        touchMultiplier: 2
    });
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add((time) => {
        lenis.raf(time * 1000);
    });
    gsap.ticker.lagSmoothing(0);
     */

    // header change
    var scrollDirection = 0;
    const headerChange = ScrollTrigger.create({
        onUpdate: (self) => {
            if(self.direction === 1){
                $('.header').addClass('scroll');
                $('.header').addClass('scroll-bottom');
            }
            else{
                $('.header').removeClass('scroll-bottom');
            }
            if(self.progress < 0.01){
                $('.header').removeClass('scroll');
            }
            scrollDirection = self.direction;
        }
    });

    /* header */
    // main menu function
    $(".js-menu-btn").click(function () {
        if(!$(this).hasClass('active')){
            $(this).addClass('active');
            $('#' + $(this).attr('data-menu')).addClass('show');
            $('body').addClass('overflow menu-show');
        }
        else{
            $(this).removeClass('active');
            $('#' + $(this).attr('data-menu')).removeClass('show');
            $('body').removeClass('overflow menu-show');
        }

    });
    $(document).click(function (e) {
        var container = $(".header");
        if (container.has(e.target).length === 0 && !e.target.classList.contains('js-menu-btn')){
            if ($('.js-menu-btn').hasClass("active")) {
                $('.js-menu-btn').removeClass('active');
                $('#main-menu').removeClass("show");
                $('body').removeClass('overflow menu-show');
            }
        }
    });
    // submenu
    if ($(window).width() > 1199) {
        $('.header .js-subitem-link').hover(
            function() {
                $(this).addClass('active');
                $(this).find('.submenu-wrapper').stop().slideDown(300);
            },
            function() {
                $(this).removeClass('active');
                $(this).find('.submenu-wrapper').stop().slideUp(300);
            }
        );
    };

    /* omg small fix */
    setTimeout(function (){
        $('.home-main .check-block').addClass('show');
    }, 800)

    /* main page */
    // programm choose function
    $(document).on('click', '.js-programm-link', function (){
        if(!$(this).hasClass('active')){
            $(this).parents('.links-list').find('.js-programm-link').removeClass('active');
            $(this).parents('.descr-side').find('.tabs-list .tabs-item').removeClass('active');
            $(this).addClass('active');
            $(this).parents('.descr-side').find('.tabs-list .tabs-item[data-tab="'+ $(this).attr('data-tab') +'"]').addClass('active');
            // close list if mobile
            $('.js-programm-current').text($(this).text());
            if($(window).width() <= 768){
                $(this).parents('.links-list').slideUp(300);
                $('.js-programm-current').removeClass('active');
            }
        }
    });
    $(document).on('click', function (e) {
        if($(window).width() <= 768){
            var container = $(".programm-section .links-list");
            if (container.has(e.target).length === 0 && !e.target.classList.contains('js-programm-current')){
                $('.js-programm-current').removeClass('active');
                $('.js-programm-current').siblings('.links-list').slideUp(300);
            }
        }
    });
    // programm mobile menu function
    $(document).on('click', '.js-programm-current', function (){
       if($(this).hasClass('active')){
           $(this).removeClass('active');
           $(this).siblings('.links-list').slideUp(300);
       }
       else{
           $(this).addClass('active');
           $(this).siblings('.links-list').slideDown(300);
       }
    });
    // faq see function
    $(document).on('click', '.js-faq-link', function (){
        var item = $(this).parents('.faq-item');
        if(item.hasClass('active')){
            $(item).removeClass('active').find('.item-descr').slideUp(300);
        }
        else{
            $(item).addClass('active').find('.item-descr').slideDown(300);
        }
    });

    // text animation
    // Определяет функцию дебаунсинга, чтобы ограничить частоту вызова функции.
    const debounce = (func, delay) => {
        let timerId;
        return (...args) => {
            clearTimeout(timerId);
            timerId = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    };
    // Класс для разбивки текста для анимации.
    class TextSplitter {
        constructor(textElement, options = {}) {
            if (!textElement || !(textElement instanceof HTMLElement)) {
                throw new Error('Invalid text element provided.');
            }

            const { resizeCallback, splitTypeTypes } = options;

            this.textElement = textElement;
            this.onResize = typeof resizeCallback === 'function' ? resizeCallback : null;

            const splitOptions = splitTypeTypes ? { types: splitTypeTypes } : {};
            this.splitText = new SplitType(this.textElement, splitOptions);

            if (this.onResize) {
                this.initResizeObserver();
            }
        }

        initResizeObserver() {
            this.previousContainerWidth = null;

            let resizeObserver = new ResizeObserver(
                debounce((entries) => this.handleResize(entries), 100)
            );
            resizeObserver.observe(this.textElement);
        }

        handleResize(entries) {
            const [{ contentRect }] = entries;
            const width = Math.floor(contentRect.width);
            if (this.previousContainerWidth && this.previousContainerWidth !== width) {
                this.splitText.split();
                this.onResize();
            }
            this.previousContainerWidth = width;
        }

        revert() {
            return this.splitText.revert();
        }

        getLines() {
            return this.splitText.lines;
        }

        getWords() {
            return this.splitText.words;
        }

        getChars() {
            return this.splitText.chars;
        }
    }
    const lettersAndSymbols = ['а', 'б', 'в', 'г', 'д', 'е', 'ё', 'ж', 'з', 'и', 'й', 'к', 'л', 'м', 'н', 'о', 'п', 'р', 'с', 'т', 'у', 'ф', 'х', 'ц', 'ч', 'ш', 'щ', 'ъ', 'ы', 'ь', 'э', 'ю', 'я', '!', '@', '#', '$', '%', '^', '&', '*', '-', '_', '+', '=', ';', ':', '<', '>', ','];
    class TextAnimator {
        constructor(textElement) {
            if (!textElement || !(textElement instanceof HTMLElement)) {
                throw new Error('Invalid text element provided.');
            }

            this.textElement = textElement;
            this.splitText();
        }

        splitText() {
            this.splitter = new TextSplitter(this.textElement, {
                splitTypeTypes: 'words, chars'
            });

            this.originalChars = this.splitter.getChars().map(char => char.innerHTML);
        }

        animate() {
            this.reset();

            const chars = this.splitter.getChars();
            chars.forEach((char, position) => {
                let initialHTML = char.innerHTML;
                let repeatCount = 0;

                gsap.fromTo(char, {
                        opacity: 0
                    },
                    {
                        duration: 0.03,
                        onStart: () => {
                            gsap.set(char, { '--opa': 1 });
                        },
                        onComplete: () => {
                            gsap.set(char, {innerHTML: initialHTML, delay: 0.03});
                        },
                        repeat: 3,
                        onRepeat: () => {
                            repeatCount++;
                            if (repeatCount === 1) {
                                gsap.set(char, { '--opa': 0 });
                            }
                        },
                        repeatRefresh: true,
                        repeatDelay: 0.04,
                        delay: (position + 1) * 0.07,
                        innerHTML: () => lettersAndSymbols[Math.floor(Math.random() * lettersAndSymbols.length)],
                        opacity: 1
                    });
            });
        }

        reset() {
            const chars = this.splitter.getChars();
            chars.forEach((char) => {
                gsap.killTweensOf(char);  // Сбиваем анимации
                char.innerHTML = this.originalChars[chars.indexOf(char)];  // Возвращаем символы на место
            });
        }
    }
    const init = () => {
        // Добавляем анимацию при ховере на все элементы с классом .hover-effect
        document.querySelectorAll('.primary-btn').forEach(item => {
            const animator = new TextAnimator(item);

            // Анимация при ховере
            item.addEventListener('mouseenter', () => {
                animator.animate();
            });

            // Используем ScrollTrigger для анимации при появлении на экране
            /*
            gsap.timeline({
                scrollTrigger: {
                    trigger: item,
                    start: "top bottom",  // Начало анимации, когда элемент появляется внизу экрана
                    end: "bottom bottom", // Конец анимации, когда элемент полностью проходит
                    toggleActions: "none play none reset" // Запускаем анимацию, когда элемент попадает в область видимости
                }
            }).add(() => {
                animator.animate();
            });
             */
        });

    };
    init();

    // certificate block animation
    if($('.certificate-section').length > 0 && $(window).width() > 768) {
        const rowSections = gsap.utils.toArray(".certificate-section");
        rowSections.forEach((section) => {
            var rowItems = Array.from(section.querySelectorAll('.decor-block'));
            rowItems.forEach((item, index) => {
                const anim = gsap.fromTo(item,
                    {
                        yPercent: 100
                    },
                    {
                        yPercent: -50
                    }
                );
                ScrollTrigger.create({
                    trigger: section,
                    animation: anim,
                    scrub: 1
                });
            });
        });
    }

    /* capital page */
    // main types hover
    $(document).on({
        mouseenter: function () {
            $(this).parent().find('.type-item').removeClass('active');
            $(this).addClass('active');
        }
    }, ".capital-main .type-item");
    // use section tabs
    $(document).on('click', '.js-use-link', function (){
       $(this).parent().find('.js-use-link').removeClass('active');
       $(this).addClass('active');
       $(this).parents('.use-section__content').find('.tabs-list .tabs-item').removeClass('active');
       $(this).parents('.use-section__content').find('.tabs-list .tabs-item[data-tab="'+ $(this).attr('data-tab') +'"]').addClass('active');
    });
    // help block animation
    if($(window).width() > 1024){
        $(document).on({
            mouseenter: function () {
                $(this).addClass('active').find('.block-descr').stop().slideDown(500);
            },
            mouseleave: function () {
                $(this).removeClass('active').find('.block-descr').stop().slideUp(500);
            }
        }, ".js-help-block");
    }
    else{
        $(document).on('click', '.js-help-title', function (){
            if($(this).parent().hasClass('active')){
                $(this).parent().removeClass('active');
                $(this).parent().find('.block-descr').stop().slideUp(500);
            }
            else{
                $(this).parent().addClass('active');
                $(this).parent().find('.block-descr').stop().slideDown(500);
            }
        });
    }

    // modal video play
    $(document).on({
        mouseenter: function () {
            $(this).find('video')[0].play();
        },
        mouseleave: function () {
            $(this).find('video')[0].pause();
        }
    }, ".js-video-hover");
    // consult choose function
    $(document).on('change', '#consultation_modal input[name="house"], .consultation-section input[name="house"]', function (){
        var form = $(this).parents('form'),
            type = '';
        if(form.find('input[name="house"]:checked').length < 1){
            type = 'none';
        }
        else{
            if(form.find('input[value="build"]').prop('checked')){
                type += 'build';
            }
            if(form.find('input[value="9"]').prop('checked')){
                type += '9';
            }
            if(form.find('input[value="17"]').prop('checked')){
                type += '17';
            }
        }
        form.find('.text-item').removeClass('active');
        form.find('.text-item[data-type="'+ type +'"]').addClass('active');
    });

    /* modals */
    // simple modal
    $('.js-simple-modal').magnificPopup({
        type: 'inline',
        fixedContentPos: false,
        fixedBgPos: false,
        showCloseBtn: false,
        tClose: 'Закрыть',
        removalDelay: 300,
        mainClass: 'mfp-zoom-in',
        callbacks: {
            open: function(e) {
                $('body').addClass('overflow');
                // lenis.stop();
            },
            close: function() {
                $('body').removeClass('overflow');
                // lenis.start();
            }
        }
    });
    // image modal
    $('.js-image-link').magnificPopup({
        type: 'image',
        mainClass: 'mfp-zoom-in',
        fixedContentPos: false,
        removalDelay: 300,
        preloader: true,
        tClose: 'Закрыть',
        image: {
            tError: 'Невозможно загрузить :('
        },
        callbacks: {
            open: function() {
                $('body').addClass('overflow');
                // if lenis.js
                // lenis.stop();
            },
            close: function() {
                $('body').removeClass('overflow');
                // if lenis.js
                // lenis.start();
            }
        }
    });
    // close modal
    $(document).on('click', '.js-modal-close', function (){
        $.magnificPopup.close();
    });

    // main page
    // projects slider
    $('.js-projects-slider').each(function (index, slider) {
        var projectsSlider = new Swiper(slider, {
            slidesPerView: 'auto',
            loop: true,
            watchSlidesProgress: true,
            slidesOffsetAfter: 0,
            loopAdditionalSlides: 3,
            speed: 800,
            spaceBetween: 8,
            navigation: {
                nextEl: $(slider).find('.slider-navigation .nav-btn.next-btn')[0],
                prevEl: $(slider).find('.slider-navigation .nav-btn.prev-btn')[0],
            },
            pagination: {
                clickable: true,
                el: $(slider).find('.slider-pagination')[0],
            },
            breakpoints: {
                1441: {
                    slidesOffsetAfter: 430,
                    loopAdditionalSlides: 3,
                },
                769: {
                    slidesOffsetAfter: ((20.7 * 2) * ((window.innerWidth * 0.694) / 100)) + 11,
                    loopAdditionalSlides: 3,
                }
            }
        });
    });
    // answers slider
    $('.js-answers-slider').each(function (index, slider) {
        var answersSlider = new Swiper(slider, {
            slidesPerView: 'auto',
            loop: true,
            watchSlidesProgress: true,
            speed: 800,
            autoplay: false,
            spaceBetween: 12,
            pagination: {
                clickable: true,
                el: $(slider).find('.slider-pagination')[0],
            },
            breakpoints: {
                768: {
                    autoplay: {
                        delay: 0,
                        pauseOnMouseEnter: true,
                        disableOnInteraction: false
                    },
                    speed: 5000,
                }
            }
        });
        if($(window).width() > 767){
            $(slider).hover(
                function (){
                    answersSlider.autoplay.stop();
                    answersSlider.params.speed = 800;
                },
                function (){
                    answersSlider.params.speed = 5000;
                    answersSlider.autoplay.start();
                }
            )
        }
    });
    // houses slider
    $('.js-houses-slider').each(function (index, slider) {
        var housesSlider = new Swiper(slider, {
            slidesPerView: 'auto',
            loop: true,
            watchSlidesProgress: true,
            slidesOffsetAfter: 0,
            loopAdditionalSlides: 3,
            speed: 800,
            spaceBetween: 16,
            navigation: {
                nextEl: $(slider).parent().find('.slider-navigation .nav-btn.next-btn')[0],
                prevEl: $(slider).parent().find('.slider-navigation .nav-btn.prev-btn')[0],
            },
            pagination: {
                clickable: true,
                el: $(slider).find('.slider-pagination')[0],
            },
            breakpoints: {
                1441: {
                    slidesOffsetAfter: 430,
                    loopAdditionalSlides: 3,
                },
                769: {
                    slidesOffsetAfter: ((20.7 * 2) * ((window.innerWidth * 0.694) / 100)) + 11,
                    loopAdditionalSlides: 3,
                }
            }
        });
    });

    // solutions show
    if($(window).width() > 768){
        $(document).on(
            {
                mouseenter: function () {
                    if(!$(this).hasClass('active')){
                        $(this).parents('.home-solutions__content').find('.js-solution-link').removeClass('active');
                        $(this).parents('.home-solutions__content').find('.js-solution-link').find('.item-descr .descr-txt').stop().slideUp(150);
                        $(this).addClass('active');
                        $(this).find('.item-descr .descr-txt').stop().slideDown(150);
                    }
                },
                mouseleave: function () {
                }
            }, ".js-solution-link");
    }
    // solutions slider
    if($('.js-solutions-slider').length > 0){
        var slidersInit = false,
            solutionSlider = Swiper;
        function solutionInit(){
            if($(window).width() < 769){
                if(!slidersInit){
                    slidersInit = true;
                    $('.js-solutions-slider').each(function (index, slider) {
                        solutionSlider = new Swiper(slider, {
                            slidesPerView: 'auto',
                            watchSlidesProgress: true,
                            speed: 800,
                            spaceBetween: 4
                        });
                    });
                }
            }
            else{
                if(slidersInit){
                    solutionSlider.destroy();
                    slidersInit = false;
                }
            }
        }
        solutionInit();
        $(window).on('resize', function (){
            solutionInit();
        });
    };

    // tags slider
    $('.js-tags-slider').each(function (index, slider) {
        var tagsSlider = new Swiper(slider, {
            slidesPerView: 'auto',
            loop: false,
            // watchSlidesProgress: true,
            speed: 800,
            spaceBetween: 0,
            // watchOverflow: true,
            freeMode: true,
            grabCursor: true,
            mousewheel: {
                forceToAxis: true,
            },
            navigation: {
                nextEl: $(slider).find('.slider-navigation .nav-btn.next-btn')[0],
                prevEl: $(slider).find('.slider-navigation .nav-btn.prev-btn')[0],
            },
        });
    });

    // equipment slider
    $('.equipment-section').each(function (index, section){
        var init = false;
        var equipSlider = Swiper;
        function equipInit(){
            if($(window).width() < 769){
                if(!init){
                    init = true;
                    $(section).find('.js-equipment-slider').each(function(index, slider) {
                        equipSlider = new Swiper(slider, {
                            slidesPerView: 'auto',
                            watchSlidesProgress: true,
                            speed: 800,
                            spaceBetween: 0,
                            pagination: {
                                clickable: true,
                                el: $(slider).find('.slider-pagination')[0],
                            }
                        });
                    });
                }
            }
            else{
                if(init){
                    equipSlider.destroy();
                    init = false;
                }
            }
        }
        equipInit();
        $(window).on('resize', function (){
            equipInit();
        });
    });

    // faq category choose
    $(document).on('click', '.js-faq-tab', function (){
       if(!$(this).hasClass('active')){
           // change active
           $(this).parents('.categories-list').find('.js-faq-tab').removeClass('active');
           $(this).addClass('active');
           // change tag
           $(this).parents('.faq-wrapper').find('.category-tab').removeClass('active');
           $(this).parents('.faq-wrapper').find('.category-tab[data-tab="'+ $(this).attr('data-tab') +'"]').addClass('active');
           // change text
           $(this).parents('.categories-block').find('.js-category-btn').text($(this).text());
       }
    });
    $(document).on('click', '.js-category-btn', function (){
       if(!$(this).hasClass('active')){
           $(this).addClass('active');
           $(this).siblings('.categories-list').slideDown(300);
       }
       else{
           $(this).removeClass('active');
           $(this).siblings('.categories-list').slideUp(300);
       }
    });
    if($(window).width() <= 992){
        $(document).on('click', function (e) {
            const $container = $('.js-category-btn').parent();
            if (!$container.is(e.target) && !e.target.classList.contains('js-category-btn')) {
                $('.js-category-btn').removeClass('active');
                $('.categories-list').slideUp(300);
            }
        });
    }



    // phone mask
    $.fn.setCursorPosition = function(pos) {
        if ($(this).get(0).setSelectionRange) {
            $(this).get(0).setSelectionRange(pos, pos);
        } else if ($(this).get(0).createTextRange) {
            var range = $(this).get(0).createTextRange();
            range.collapse(true);
            range.moveEnd('character', pos);
            range.moveStart('character', pos);
            range.select();
        }
    };
    $('.js-phone-input').click(function (){
        $(this).setCursorPosition(4);
    }).mask("+7 (999) 999-99-99");


    /* old js */
    // custom select
    $(document).on('click', '.js-custom-select .js-current-value', function() {
        if ($(this).parent().hasClass('active')) {
            $(this).parent().toggleClass('active');
            $(this).toggleClass('active');
            $(this).parent().find('.list-wrapper').slideToggle(300);
        } else {
            $('.js-custom-select.active .js-current-value').removeClass('active');
            $('.js-custom-select.active .list-wrapper').slideUp(0);
            $('.js-custom-select.active').removeClass('active');
            $(this).parent().toggleClass('active');
            $(this).toggleClass('active');
            $(this).parent().find('.list-wrapper').slideToggle(300);
        }
    });
    // close custom select
    $(document).on('click', function(e) {
        if (!e.target.classList.contains('js-current-value') && !e.target.classList.contains('checkbox-label') && !e.target.classList.contains('checkbox-input')) {
            $('.js-custom-select.active .js-current-value').removeClass('active');
            $('.js-custom-select.active .list-wrapper').slideUp(0);
            $('.js-custom-select.active').removeClass('active');
        };
    });
    // filter form check show
    $('.js-filter-form').each(function (index, form){
        // prepare on load
        $(form).parents('.js-form-wrapper').find('.js-check-list .js-check-item').remove();
        $(this).find('input[type="checkbox"]:checked').each(function (index, el){
            $(this).parents('.js-form-wrapper').find('.js-check-list').prepend('<a href="javascript:void(0);" class="check-item js-check-item" data-value="'+ $(this).attr('value') +'">'+ $(this).siblings('span').text() +'</a>');
        });
        if($(form).parents('.js-form-wrapper').find('.js-check-list .js-check-item').length > 0){
            $(form).parents('.js-form-wrapper').find('.js-clean-list').fadeIn(300);
        };
        if($(form).parents('.js-form-wrapper').find('.js-check-list .js-check-item').length > 4){
            $(form).parents('.js-form-wrapper').find('.js-show-list').fadeIn(300);
        };
        // change
        $(form).on('change', function (){
            $(form).parents('.js-form-wrapper').find('.js-check-list .js-check-item').remove();
            $(this).find('input[type="checkbox"]:checked').each(function (index, el){
                $(this).parents('.js-form-wrapper').find('.js-check-list').prepend('<a href="javascript:void(0);" class="check-item js-check-item" data-value="'+ $(this).attr('value') +'">'+ $(this).siblings('span').text() +'</a>');
            });
            if($(form).parents('.js-form-wrapper').find('.js-check-list .js-check-item').length > 0){
                $(form).parents('.js-form-wrapper').find('.js-clean-list').fadeIn(300);
            };
            if($(form).parents('.js-form-wrapper').find('.js-check-list .js-check-item').length > 4){
                $(form).parents('.js-form-wrapper').find('.js-show-list').fadeIn(300);
            };
        });
        $(form).parents('.js-form-wrapper').on('click', '.js-check-item', function (){
            $(form).find('input[type="checkbox"][value="'+ $(this).attr('data-value') +'"]').prop('checked', false);
            $(this).remove();
            mSearch2.submit();
            if($(form).parents('.js-form-wrapper').find('.js-check-list .js-check-item').length < 1){
                $(form).parents('.js-form-wrapper').find('.js-clean-list').fadeOut(300);
            };
            if($(form).parents('.js-form-wrapper').find('.js-check-list .js-check-item').length < 5){
                $(form).parents('.js-form-wrapper').find('.js-show-list').fadeOut(300);
            };
        });
        $(form).parents('.js-form-wrapper').on('click', '.js-show-list', function (){
            $(this).toggleClass('active');
            $(form).parents('.js-form-wrapper').find('.js-check-list').toggleClass('show');
        });
        $(form).parents('.js-form-wrapper').on('click', '.js-clean-list', function (){
            $(form).find('input[type="checkbox"]').prop('checked', false);
            $(form).parents('.js-form-wrapper').find('.js-check-list .js-check-item').remove();
            $(form).parents('.js-form-wrapper').find('.js-show-list').fadeOut(0).removeClass('active');
            $(form).parents('.js-form-wrapper').find('.js-show-list').fadeOut(0).removeClass('active');
            $(form).parents('.js-form-wrapper').find('.js-clean-list').fadeOut(0);
            $(form).parents('.js-form-wrapper').find('.js-check-list').removeClass('show');
            mSearch2.reset();
        });
    });
    // videos filter fix
    $('.videos-main__tags').on('change', function (){
        $('.videos-main__tags .js-filter-reset').removeClass('active');
    });
    $(document).on('click', '.js-filter-reset', function (){
        mSearch2.reset();
        $(this).addClass('active');
    });

    // form privacy check
    $('.js-form-check').on('submit', function(e){
        if(!$(this).find('input[type="checkbox"][name="check[]"]').prop('checked')){
            $(this).find('input[type="checkbox"][name="check[]"]').siblings('.label').addClass('error-check');
            e.preventDefault();
        }
        else{
            $(this).find('input[type="checkbox"][name="check[]"]').siblings('.label').removeClass('error-check');
        }
    });

    // filter reload fix
    $(document).on('mse2_load', function(e, data) {
        // video modal
        $('.js-video-link').magnificPopup({
            type: 'iframe',
            mainClass: 'my-mfp-zoom-in',
            fixedContentPos: true,
            removalDelay: 160,
            preloader: false,
            tClose: 'Закрыть',
            callbacks: {
                open: function() {
                    $('body').addClass('overflow');
                },
                close: function() {
                    $('body').removeClass('overflow');
                }
            }
        });
    });
    // stocks
    if(Cookies.get('stocksCookie') != 'hidden'){
        setTimeout(function (){
            $('#bottomNotice').removeClass('hide').fadeIn(300);
        }, 1000)
    };
    $('.js-notice-close').on('click',function(){
        Cookies.set('stocksCookie', 'hidden', { expires: 1 });
        $('#bottomNotice').addClass('hide').fadeOut(300);
    });

    // privacy message
    if(Cookies.get('privacyCookie') != 'hidden'){
        setTimeout(function (){
            $('#privacyNotice').fadeIn(300);
        }, 1000)
    };
    $('.js-privacy-close').on('click',function(){
        Cookies.set('privacyCookie', 'hidden', { expires: 1 });
        $('#privacyNotice').fadeOut(300);
    });

    /* scroll top btn */
    $(document).on('click', '.js-scrolltop-btn', function (){
        $(window).scrollTop(0);
    });
    $(window).scroll(function(){
        var offset = $('main > section:eq(0)').offset().top + $('main > section:eq(0)').height(),
            scroll = $(this).scrollTop();
        if(scroll > offset){
            $('.footer .fixed-wrapper').fadeIn(300);
        }
        else{
            $('.footer .fixed-wrapper').fadeOut(300);
        }

    });

    /* scroll link */
    $(document).on('click', '.js-scroll-link', function (){
        var headerHeight = $('.header').outerHeight(),
            offsetValue = 30;

        if($('#' + $(this).attr('data-ancor')).length > 0){
            $(window).scrollTop($('#'+ $(this).attr('data-ancor')).offset().top - headerHeight - offsetValue);
        }

    });

    /* more btn */
    $(document).on('click', '.js-seo-more', function (){
       var curText = $(this).text(),
           addText = $(this).attr('data-text');

       if($(this).hasClass('active')){
           $(this).removeClass('active');
           $(this).siblings('.content-wrapper').removeClass('show');
       }
       else{
           $(this).addClass('active');
           $(this).siblings('.content-wrapper').addClass('show');

       }
       $(this).attr('data-text', curText).text(addText);
    });

    /* main page adv function */
    if ($('.info-section').length > 0) {
        const $blocks = $('.js-info-block');
        const intervalTime = 7000;
        let currentIndex = 0;
        let timer = null;

        function activateBlock(index) {
            $blocks.each(function() {
                $(this).css({
                    '--speed': '0s',
                    '--progress': '0%'
                }).removeClass('active');
            });

            currentIndex = index;
            const $current = $blocks.eq(index);
            const $other = $blocks.not($current);

            $other.removeClass('active').find('.descr-txt').stop(true, true).slideUp(300);
            if ($(window).width() <= 992) {
                $other.find('.image-block').stop(true, true).slideUp(300);
            }

            $current.addClass('active').find('.descr-txt').stop(true, true).slideDown(300);
            if ($(window).width() <= 992) {
                $current.find('.image-block').stop(true, true).slideDown(300);
            }

            // Запуск анимации прогресс-бара
            setTimeout(() => {
                $current.css({
                    '--speed': intervalTime + 'ms',
                    '--progress': '100%'
                });
            }, 50);
        }

        function startAutoCycle() {
            clearInterval(timer);
            timer = setInterval(() => {
                let nextIndex = (currentIndex + 1) % $blocks.length;
                activateBlock(nextIndex);
            }, intervalTime);
        }

        function stopAutoCycle() {
            clearInterval(timer);
        }

        const isDesktop = $(window).width() > 992;
        const eventType = isDesktop ? 'mouseenter' : 'click';

        $blocks.on(eventType, function() {
            const clickedIndex = $(this).index();

            // Если блок уже активен, ничего не делаем
            if (clickedIndex === currentIndex && $(this).hasClass('active')) return;

            stopAutoCycle();
            activateBlock(clickedIndex);

            // Если это мобилка, перезапускаем цикл сразу.
            // На десктопе цикл запустится только после ухода курсора (mouseleave).
            if (!isDesktop) {
                startAutoCycle();
            }
        });

        // Логика паузы при наведении для десктопа
        if (isDesktop) {
            $blocks.on('mouseenter', function() {
                stopAutoCycle();
            });

            $blocks.on('mouseleave', function() {
                startAutoCycle();
            });
        }

        // Инициализация
        activateBlock(0);
        startAutoCycle();
    }

    // modx ajax form fix
    AjaxForm.Message.error = function(){};
    AjaxForm.Message.success = function(){};
    // thanks page
    $(document).on('af_complete', function(event,res) {
        if(res.success){
            window.location.href = "/spasibo.html"
        };
    });


    /* do not remove :) */
    showInfo();
});
